import { NewsSeoConfig } from 'libs/shared-lib/interfaces/seo/seo-partner-web';

export const NEWS_SEO_FR: NewsSeoConfig = {
    list: {
        title: 'News',
        description: '',
        image: '',
        twitter: {
            card: 'summary',
            title: 'news',
            description: '',
        },
        og: {
            title: 'News',
            description: '',
        },
        robots: {
            noIndex: false,
            noFollow: false,
        },
    },
    detail: {
        title: 'News Detail',
        description: '',
        image: '',
        twitter: {
            card: 'summary',
            title: 'news-detail',
            description: '',
        },
        og: {
            title: 'News Detail',
            description: '',
        },
        robots: {
            noIndex: false,
            noFollow: false,
        },
    },
};
